import { Button, createStyles, Dialog, DialogActions, DialogContent, DialogContentText, DialogTitle, makeStyles, Theme, Typography } from "@material-ui/core"
import { Error } from "@material-ui/icons";
import Spin from "../../../images/Spin"
import { colors } from "../../../styles/defaultColors";

const useStyles = makeStyles((theme: Theme) =>
    createStyles({
        button: {
            background: "#890608",
            color: "white",
            borderRadius: 100,
            fontFamily: 'Josefin Sans',
            fontSize: 14,
            textTransform: "none",
            padding: "8px 14px",
            marginLeft: 20,
            "&:hover": {
                background: "#B5551B"
            },
        },
        updateButton: {
            borderRadius: 100,
            textTransform: "none",
            fontSize: 14,
            marginBottom: theme.spacing(2),
            marginTop: theme.spacing(2),
            textAlign: "center",
            fontFamily: 'Josefin Sans',
            background: "#AAAAAA",
            color: "#ffffff",
            padding: "8px 14px",
            "&:hover": {
                background: "#B5551B"
            },
        },
        title: {
            borderBottom: "1px solid #9999998A"
        },
        action: {
            borderTop: "1px solid #9999998A",
        },
        content: {
            marginTop: 20
        },
        errors: {
            color: colors.danger,
            background: colors.backgroundDanger,
            width: "100%",
            textAlign: "center",
            marginTop: theme.spacing(2),
            marginBottom: theme.spacing(2),
            borderRadius: 5,
            "& p": {
                padding: 10,
            },
        },
    })
);

interface ModalProps {
    open: boolean
    handleClose: () => void
    handleSubmit: (e: any) => void
    loading: boolean
    errorMessages: string
}

export const ModalConfirm = (props: ModalProps) => {
    const classes = useStyles()

    return (
        <>
            <Dialog open={props.open} onClose={props.handleClose}>
                <DialogTitle className={classes.title}>Modification du profil</DialogTitle>
                <DialogContent className={classes.content}>
                    <DialogContentText>
                        Voulez-vous vraiment enregistrer ces modifications?
                        {props.errorMessages && (
                            <div className={classes.errors}>
                                <Typography>
                                    <Error />
                                    <br />
                                    <span>{props.errorMessages}</span>
                                </Typography>
                            </div>
                        )}
                    </DialogContentText>
                </DialogContent>
                <DialogActions className={classes.action}>
                    <Button className={classes.updateButton} onClick={props.handleClose}>Annuler</Button>
                    <Button
                        onClick={props.handleSubmit}
                        endIcon={
                            props.loading ? <Spin /> : null
                        }
                        disabled={props.errorMessages.length > 0}
                        className={classes.button}
                    >
                        Enregistrer
                    </Button>
                </DialogActions>
            </Dialog>
        </>
    )
}